<script setup lang="ts">
const documentId = inject("documentId") as any;
const thesaurusStore = useDocumentThesaurusStore(documentId);
const { currentPage } = storeToRefs(thesaurusStore);

onMounted(() => {
  const wordList = document.getElementById(
    `word-list-${currentPage.value.key}`
  );
  if (wordList) {
    wordList.scrollIntoView({ behavior: "smooth" });
  }
});
</script>

<template>
  <div v-if="currentPage.type == ThesaurusPageType.bannedWords">
    <div
      v-for="(words, key) in currentPage.data.bannedWords"
      :key="key"
      class="mb-6"
      :id="`word-list-${key}`"
    >
      <DocumentEditorReviewPanelThesaurusWordList
        :class="{
          'bg-primary-default/10 p-4 pb-6 rounded': currentPage.key == key,
        }"
      >
        <template #label>{{ key }}</template>
        <template #words>
          <DocumentEditorReviewPanelThesaurusTappableWord
            v-for="word in words"
            :key="word"
            :word="word"
            @click="
              thesaurusStore.addPage({
                label: word,
                type: ThesaurusPageType.word,
                key: word,
                data: undefined,
                isLoading: ref(true),
              })
            "
          >
            {{ word }}
          </DocumentEditorReviewPanelThesaurusTappableWord>
        </template>
      </DocumentEditorReviewPanelThesaurusWordList>
    </div>
  </div>
</template>

<style scoped></style>
